module.exports = __webpack_public_path__ + "static/media/23.64beaac7.mp3";